module.exports = __webpack_public_path__ + "img/delivery-truck.6f021976.svg";